import { render, staticRenderFns } from "./FacebookBrowserMessage.vue?vue&type=template&id=60dfadc0&scoped=true&"
import script from "./FacebookBrowserMessage.vue?vue&type=script&lang=js&"
export * from "./FacebookBrowserMessage.vue?vue&type=script&lang=js&"
import style0 from "./FacebookBrowserMessage.vue?vue&type=style&index=0&id=60dfadc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dfadc0",
  null
  
)

export default component.exports